import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import "./StackedCarousel.scss"; // Ensure CSS for the Cover Flow effect

export default function StackedCarousel({ items, renderItem }) {
  const [activeIndex, setActiveIndex] = useState(Math.floor(items.length / 2)); // Center item as default
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // Update container width on resize for better responsiveness
  const updateContainerWidth = () => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };

  useEffect(() => {
    updateContainerWidth(); // Set initial width
    window.addEventListener("resize", updateContainerWidth); // Update on window resize

    return () => {
      window.removeEventListener("resize", updateContainerWidth); // Clean up listener on unmount
    };
  }, []);

  const handleCardHover = (index) => {
    setActiveIndex(index); // Update the active card on hover
  };

  return (
    <Box
      className="coverflow-container"
      ref={containerRef}

    >
      <div className="coverflow-wrapper" style={{ width: "100%", height: "100%" }}>
        <div className="coverflow-items" style={{ display: "flex", position: "relative" }}>
          {items.map((item, index) => {
            const offset = index - activeIndex;
            const isActive = index === activeIndex;

            // Dynamically calculate the size, spacing, and scaling based on container width
            const baseWidth = containerWidth > 768 ? 250 : 200; // Adjusted card size
            const translateX = offset * (baseWidth * 0.6); // Adjust space between cards dynamically
            const scale = isActive ? 1.1 : 1 - Math.abs(offset) * 0.2; // Slightly reduced scaling effect
            const rotateY = offset * 15; // Slightly smaller rotation for inactive cards
            const zIndex = isActive ? 10 : 5 - Math.abs(offset); // Cards closer to the center have higher z-index
            const opacity = isActive ? 1 : 1 - Math.abs(offset) * 0.3; // Gradually reduce opacity for inactive cards

            return (
              <Box
                key={index}
                className={`coverflow-item ${isActive ? "active" : "inactive"}`}
                style={{
                  transform: `translateX(${translateX}px) scale(${scale}) rotateY(${rotateY}deg)`,
                  zIndex: zIndex,
                  opacity: opacity,
                  width: `${baseWidth}px`, // Adjusted card size
                  height: `${baseWidth * 1.5}px`, // Maintain aspect ratio
                  transition: "transform 0.5s ease, opacity 0.5s ease", // Smooth transitions
                }}
                onMouseEnter={() => handleCardHover(index)} // Activate card when hovered
              >
                {renderItem(item)}
              </Box>
            );
          })}
        </div>
      </div>
    </Box>
  );
}
